import Enum from "../../../../../../enums/Enum";

const MyotomesLumbarEnum = new Enum({
    M_L1_L2: {value: "L1/L2 - Hip Flexion"},
    M_L3: {value: "L3 - Knee Extension"},
    M_L4: {value: "L4 - Ankle Dorsiflexion"},
    M_L5: {value: "L5 - Great Toe Extension"},
});

export default MyotomesLumbarEnum;